import "./form_builder/field_editor.js";
import "./form_builder/form_preview.js";
import "#lib/assert.js";

class FormBuilder {
  constructor(formTemplate, formData, options) {
    var assert = new Asserter({ userMessage: "Error initializing FormBuilder" });

    this.options = jQuery.extend({ editSubmit: true, filterFields: "" }, options);

    this.formTemplate = formTemplate;
    this.fieldAttributes = formTemplate.fieldAttributes;
    this.fieldDataStubs = formTemplate.fieldDataStubs;
    this.crmDataFields = formTemplate.crmDataFields;

    this.formData = assert.presence(formData, "formData is not initialized. Should be an object, e.g. { fields: [] }");
    this.fieldsData = assert.presence(formData.fields, "formData.fields is not initialized. Should be an array.");
    this.baseTypes = {};

    this.el = jQuery("<div class='vfb'></div>");
    this.el.html(Sparkle.HandlebarsTemplates["form-builder"]());

    this.preview = new FormBuilderFormPreview(formTemplate.fixedChoiceOptions);
    this.$fieldsContainer = this.el.find("[data-behaviour=form-builder-fields-container]");
    this.$fields = this.el.find("[data-behaviour=form-builder-fields]");
    this.$fieldEditorContainer = this.el.find("[data-behaviour=form-builder-field-editor-container]");
    this.fieldEditor = new FormBuilderFieldEditor(
      this.formTemplate,
      this.formData,
      this.baseTypes,
      this.el.find("[data-behaviour=form-builder-field-editor]"),
    );

    this.el.find(".vfb-body").append(this.preview.el);

    this.initFieldSelector();
    this.updateFields();

    // BEHAVIOUR

    this.initDragEvents();
    this.$fieldsContainer.on("dblclick", "[data-behaviour=form-field-template]", (e) => {
      this.addNewFieldHandler(e);
    });
    this.preview.el.on("FB:deleteField", (e, item) => {
      this.deleteFieldHandler(item);
    });
    this.preview.el.on("FB:showFieldEditor", (e, item, isSubmit) => {
      this.handleShowFieldEditor(item, isSubmit);
    });
    this.fieldEditor.container.on("FB:saveFieldHandler", (e) => {
      this.saveFieldHandler(e);
    });
    this.fieldEditor.container.on("FB:hideFieldEditor", (e) => {
      this.hideFieldEditor(e);
    });
    this.fieldEditor.container.on("FB:deleteField", (e, item) => {
      this.deleteFieldHandler(item);
    });
  }

  // EVENT HANDLERS

  addNewFieldHandler(e) {
    e.preventDefault();
    var item = jQuery(e.target).closest(".form-field-template-item");
    this.addNewField(item);
    this.updateFields();
  }

  handleShowFieldEditor(item, isSubmit) {
    if (isSubmit && !this.options.editSubmit) {
      return;
    }

    this.fieldAttributes.submit = { submit: this.formData.submit_text || "Submit" };

    // Show Field editor
    this.preview.el.find(".selected").removeClass("selected");
    this.$fieldsContainer.hide();
    this.fieldEditor.show(item, isSubmit);
    this.$fieldEditorContainer.show();
  }

  saveFieldHandler() {
    this.persistFieldAttributes();
    this.updateFields();
  }

  deleteFieldHandler(field) {
    this.hideFieldEditor();
    this.deleteField(field);
    this.updateFields();
  }

  // ADD NEW FIELD HELPERS

  addNewField($field, index) {
    var fieldStub = this.getFieldDataStub($field.attr("template"));
    if (index !== undefined) {
      this.fieldsData.splice(index, 0, fieldStub);
    } else {
      this.fieldsData.push(fieldStub);
    }
  }

  // DELETE FIELD HELPERS

  deleteField(field) {
    this.fieldsData.splice(field.index(), 1);
    this.preview.el.find(".selected").removeClass("selected");
  }

  // SAVE FIELD HELPERS

  persistFieldAttributes() {
    var fieldData = this.fieldsData[this.selectedFieldIndex()];
    this.fieldEditor.persistAllFields(fieldData);
  }

  // RENDERING HELPERS

  initFieldSelector() {
    this.$fields.html(Sparkle.HandlebarsTemplates["form-builder-fields"]());
    // Hide fields that are not apart of the declared filter
    this.$fields.find(".form-field-template-item").each((i, node) => {
      let type = jQuery(node).attr("template");
      if (this.fieldAttributes[type].tags && !this.fieldAttributes[type].tags == []) {
        if (!this.fieldAttributes[type].tags.includes(this.options.filterFields)) {
          jQuery(node).hide();
        }
      }
    });
    this.fieldEditor.setBaseTypes(this.findBaseTypes());
  }

  findBaseTypes() {
    var baseTypes = {};
    this.$fields.find(".form-field-template-item").each((i, node) => {
      var item = jQuery(node);
      baseTypes[item.attr("template")] = item.data("type");
    });
    this.baseTypes = baseTypes;
    return baseTypes;
  }

  // UPDATE METHODS

  updateFields() {
    if (this.options.onUpdate) {
      this.options.onUpdate(this.fieldsData);
    }

    this.$fields.find(".form-field-template-item").removeClass("disabled");

    jQuery.each(this.fieldsData, (i, value) => {
      var fieldName = value.type;
      if (this.crmDataFields.includes(fieldName)) {
        // Disable Field
        this.$fields.find("[template=" + fieldName + "]").addClass("disabled");
      } else if (this.fieldAttributes[fieldName].uniqueElement) {
        this.$fields.find("[template=" + fieldName + "]").addClass("disabled");
      }
    });

    this.preview.render({
      fields: this.fieldsData,
      selected_index: this.selectedFieldIndex(),
      submit_text: this.formData.submit_text,
    });
    this.initPreviewDragEvents();
  }

  // EDIT FIELD HELPERS

  hideFieldEditor() {
    this.$fieldEditorContainer.hide();
    this.fieldEditor.hide();
    this.$fieldsContainer.show();
  }

  // DRAG HELPERS

  initDragEvents() {
    this.initSidebarDragEvents();
    this.initPreviewDragEvents();
  }

  initSidebarDragEvents() {
    let copyHelper;

    const dragContainer = this.$fieldsContainer.find(".drag-container");

    const scrollContainer = this.el.find(".vfb-body");
    const scrollIntervalTimeout = 10;
    let scrollInterval;

    const createScrollInterval = (direction) => {
      const distance = 10;

      if (!scrollInterval) {
        scrollInterval = setInterval(() => {
          scrollContainer.scrollTop(scrollContainer.scrollTop() + distance * direction);
        }, scrollIntervalTimeout);
      }
    };

    const clearScrollInterval = () => {
      clearInterval(scrollInterval);
      scrollInterval = null;
    };

    dragContainer.sortable({
      connectWith: ".editable-fields-container",
      forcePlaceholderSize: false,
      appendTo: document.body,
      items: ".form-field-template-item:not(.disabled)",
      tolerance: "pointer",
      helper: (e, li) => {
        this.preview.el.find(".editable-fields-container").addClass("editable-fields-container-drop-ready");
        copyHelper = li.clone().insertAfter(li);
        return li.clone();
      },
      sort: (e, ui) => {
        const scrollContainerHeight = scrollContainer.height();
        const scrollContainerOffset = scrollContainer.offset();

        const { offset, item } = ui;
        const itemHeight = item.height();

        if (offset.top + itemHeight > scrollContainerHeight + scrollContainerOffset.top) {
          createScrollInterval(1);
        } else if (offset.top - itemHeight < scrollContainerOffset.top) {
          createScrollInterval(-1);
        } else {
          clearScrollInterval();
        }
      },
      stop: (e, ui) => {
        this.preview.el.find(".editable-fields-container").removeClass("editable-fields-container-drop-ready");
        if (ui.item.parents(".vfb-side-panel").length > 0) {
          copyHelper.remove();
          dragContainer.sortable("cancel");
        }
        clearScrollInterval();
      },
    });
  }

  initPreviewDragEvents() {
    this.preview.el.find(".editable-fields-container").sortable({
      receive: (e, ui) => {
        this.addNewField(ui.item, ui.item.index());
        this.updateFields();
      },
      update: (e, ui) => {
        // If the sender is not from the preview element then assume
        // that the receive function has handled the ordering
        if (ui.sender && ui.sender.hasClass("drag-container")) {
          return;
        }
        this.fieldsData.splice(ui.item.index(), 0, this.fieldsData.splice(ui.item.data("index"), 1)[0]);
        this.updateFields();
      },
    });
  }

  // HELPER METHODS

  getFieldDataStub(type) {
    return jQuery.extend({}, this.fieldDataStubs[type] || {}, { type: type });
  }

  selectedFieldIndex() {
    return this.preview.el.find(".selected").index();
  }
}

window.FormBuilder = FormBuilder;
